



































import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '../../sw-extended-vue';
import { SwSlider } from '../../sw-slider';
import { SwIconButton } from '../../sw-icon-button';

/**
 * @event zoom-change `(value: number)`
 * @event reset-map `()`
 */
@Component({
  components: {
    SwSlider,
    SwIconButton,
  },
})
export default class SwMapZoom extends SwExtendedVue {
  @Prop({ type: Number, default: 1 })
  value: number;

  @Prop({ type: Number, required: true })
  maxZoom: number;

  handler(evt: Event) {
    evt.stopPropagation();
  }

  // receive slider evt.
  handleChange(value: number) {
    this.$emit('zoom-change', value);
  }

  handleZoomBtn(dir: 'in' | 'out') {
    if (dir === 'in') {
      (this.$refs.zoomSlider as SwSlider).increaseValue();
    } else {
      (this.$refs.zoomSlider as SwSlider).decreaseValue();
    }
  }
  handleResetBtn() {
    this.$emit('reset-map');
  }
}
